import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Container Type',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/adm/conf',
      },
      {
        text: 'Container Type',
        href: '/adm/conf/container-type',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_container_type',
    sortDesc: true,
    fields: [
      {
        key: 'code_type',
        label: 'Kode',
        thStyle: {
          width: '150px',
        },
        sortable: true,
      },
      {
        key: 'code_description',
        label: 'Deskripsi',
        sortable: true,
      },
      {
        key: 'aksi',
        label: 'Aksi',
        thStyle: {
          width: '100px',
        },
      },
    ],
    detail: false,
    form: {
      code_type: '',
      code_description: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  form_bank(state) {
    return state.data.form_bank;
  },
};

export const mutations = {
  changeContainerType(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchContainerType(context, params = null) {
    let result = await ApiGetRequest(`conf/container-type`, params);
    return !result.error ? result.data.object : [];
  },

  async getListBankAccount({ commit, state }) {
    commit('changeContainerType', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      id_company: data.id_company,
    };

    let result = await ApiGetRequest(`opr/bank-account`, params);
    commit('changeContainerType', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getListContainerType({ commit, state }) {
    commit('changeContainerType', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`conf/container-type`, params);
    commit('changeContainerType', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailContainerType({ commit, state }, payload = null) {
    commit('changeContainerType', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`conf/container-type/${payload.id}`);
    commit('changeContainerType', {
      loading: false,
      form: {
        ...data.form,
        ...result.data.object,
      },
    });

    return result.error ? false : true;
  },

  async createBankAccount({ commit, state, dispatch }) {
    commit('changeContainerType', {
      loading: true,
    });

    let result = await ApiPostRequest(`opr/bank-account`, state.data.form_bank);
    commit('changeContainerType', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateBankAccount({ commit, state, dispatch }, payload = null) {
    commit('changeContainerType', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `opr/bank-account/${payload.id}`,
      state.data.form_bank
    );

    commit('changeContainerType', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteBankAccount({ commit, dispatch }, payload = null) {
    commit('changeContainerType', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/bank-account/${payload.id}`);
    commit('changeContainerType', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async createContainerType({ commit, state, dispatch }) {
    commit('changeContainerType', {
      loading: true,
    });

    let result = await ApiPostRequest(`conf/container-type`, state.data.form);
    commit('changeContainerType', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateContainerType({ commit, state, dispatch }, payload = null) {
    commit('changeContainerType', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `conf/container-type/${payload.id}`,
      state.data.form
    );

    commit('changeContainerType', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteContainerType({ commit, dispatch }, payload = null) {
    commit('changeContainerType', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`conf/container-type/${payload.id}`);
    commit('changeContainerType', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
